import { combineReducers } from 'redux';
import Auth from './Auth';
import CartReducer from './Cart';
import FetchedData from './Data';
import Theme from './Theme';

const reducers = combineReducers({
    theme: Theme,
    auth: Auth,
    fetchedData: FetchedData,
    cartData: CartReducer,
});

export default reducers;